const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 


const selector = '.header-cart.action-area__link.has-cart-count';

const waitForHeaderCart = setInterval(() => {
  const el = document.querySelector(selector);

  if (el && window.BSS_B2B?.observer?.cartSubject) {

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if (el.classList.contains('show-mini-cart')) {
            BSS_B2B.observer.cartSubject.notifyObserver(
              'CartUpdate',
              'CartMutate'
            );
          }
        }
      });
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ["class"]
    });

    clearInterval(waitForHeaderCart);
  }
}, 100);

let counter = 0;

const interval = setInterval(() => {
    const btn = document.querySelector(".cart__nt-button");

    if (window.BSS_B2B && btn && BSS_B2B.nt?.appliedRule) {
        btn.style.display = "block";
        clearInterval(interval);
        return;
    }

    counter += 100;
    if (counter >= 10000) {
        clearInterval(interval);
    }
}, 100);


const observer = new MutationObserver((mutations) => {
    const shippingWrapper = document.querySelector(".b2b-nt-shipping-method-wrapper");
    
    if (shippingWrapper) {
        
        const firstNameInput = document.querySelector("#first-name");
        const firstName = firstNameInput ? firstNameInput.value.trim() : "";

        const addressText = document.querySelector(".b2b-nt-shipping-method-wrapper p");
        if (addressText && firstName) {
            const currentAddress = addressText.innerText.trim();
            if (!currentAddress.startsWith(firstName)) {
                addressText.innerText = `${firstName} ${currentAddress}`;
            }
        }

        const shippingLabels = document.querySelectorAll(".b2b-nt-shipping-method-option label");
        shippingLabels.forEach(label => {
            if (label.innerText.match(/\s*\[\d+\]/)) {
                label.innerText = label.innerText.replace(/\s*\[\d+\]/g, "");
            }
        });
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});
